/**
 * @file コンポーネント：フル動画ページ症例基本データ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Surgeonlist } from "~/src/components/projects/Surgeonlist";
import { ButtonFavorite } from "~/src/components/projects/Video/ButtonFavorite";
import { ButtonRate } from "~/src/components/projects/Video/ButtonRate";
import { SelectLanguage } from "~/src/components/projects/Video/SelectLanguage";
import { Taglist } from "~/src/components/projects/Video/Taglist";

// 関数読み込み
import { fnReplaceLocalizedText } from "~/src/functions/common";

// スタイル読み込み
import {
    StyledData,
    StyledDataContent,
    StyledDataContentActionlist,
    StyledDataContentActionlistItem,
    StyledDataContentMetalist,
    StyledDataContentMetalistDetail,
    StyledDataContentMetalistItem,
    StyledDataContentMetalistTerm,
    StyledDataContents,
    StyledDataEdit,
    StyledDataEditLink,
    StyledDataEditLinkIcon,
    StyledDataEditLinkText,
    StyledDataLabel,
    StyledDataLabellist,
    StyledDataLabellistItem,
    StyledDataSurgeonlist,
    StyledDataTitle,
    StyledDataTitleButton,
    StyledDataTitleText,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledData>
            {/* 症例タイトル */}
            <StyledDataTitle>
                <StyledDataTitleText ref={props.refTitle}>
                    {props.title}
                </StyledDataTitleText>
                {props.isEditPage === true && (
                    // 執刀医権限の場合のみ
                    <StyledDataEdit>
                        <StyledDataEditLink
                            href="#"
                            onClick={(e) =>
                                props.fnSetModalEdit(e, "title", "edit", {
                                    context: props.refTitle.current.innerText,
                                    languageCode: props.languageCodeOperation,
                                    summary: props.refSummary.current.innerText,
                                    targets: [props.refTitle.current],
                                })
                            }
                        >
                            <StyledDataEditLinkIcon>
                                <i className="fas fa-edit"></i>
                            </StyledDataEditLinkIcon>
                            <StyledDataEditLinkText>
                                {localized["Label.Edit"]}
                            </StyledDataEditLinkText>
                        </StyledDataEditLink>
                    </StyledDataEdit>
                )}
                <StyledDataTitleButton
                    onClick={() => props.setIsOpen(!props.isOpen)}
                >
                    {props.isOpen === true ? (
                        <i className="fas fa-chevron-up"></i>
                    ) : (
                        <i className="fas fa-chevron-down"></i>
                    )}
                </StyledDataTitleButton>
            </StyledDataTitle>
            <StyledDataContents className={props.isOpen && "is-open"}>
                <StyledDataLabellist>
                    {props.isEditPage !== true && props.isPaid === true && (
                        // 購入状態ラベル（執刀医権限、管理者権限でない有料コンテンツの場合）
                        <StyledDataLabellistItem>
                            <StyledDataLabel
                                data-label-type={
                                    props.isPurchased === true
                                        ? "purchased"
                                        : "paid"
                                }
                            >
                                {props.isPurchased === true
                                    ? // 購入済み
                                      localized["Label.Purchased"]
                                    : // 未購入
                                      localized["Label.NotPurchased"]}
                            </StyledDataLabel>
                        </StyledDataLabellistItem>
                    )}
                    {props.isEditPage === true && (
                        // 編集権限ラベル
                        <StyledDataLabellistItem>
                            <StyledDataLabel data-label-type="edit">
                                {props.isAdminUser === true
                                    ? // 管理者権限
                                      localized["Label.PageAdminAuthority"]
                                    : // 執刀医権限
                                      localized["Label.PageSurgeonAuthority"]}
                            </StyledDataLabel>
                            {props.isAdminUser === true && (
                                // 管理者権限ユーザーのみ、執刀医権限編集リンク
                                <StyledDataEdit>
                                    <StyledDataEditLink
                                        href="#"
                                        onClick={(e) =>
                                            props.fnSetModalEdit(
                                                e,
                                                "surgeonuserlist",
                                                "edit",
                                                {
                                                    list: props.surgeonUserList,
                                                }
                                            )
                                        }
                                    >
                                        <StyledDataEditLinkIcon>
                                            <i className="fas fa-edit"></i>
                                        </StyledDataEditLinkIcon>
                                        <StyledDataEditLinkText>
                                            {fnReplaceLocalizedText(
                                                localized["Label.EditContent"],
                                                [localized["Label.SurgeonUser"]]
                                            )}
                                        </StyledDataEditLinkText>
                                    </StyledDataEditLink>
                                </StyledDataEdit>
                            )}
                        </StyledDataLabellistItem>
                    )}
                </StyledDataLabellist>
                <StyledDataContent>
                    <StyledDataContentMetalist>
                        {/* 閲覧数 */}
                        {props.isCollaboration ? (
                            <></>
                        ) : (
                            <StyledDataContentMetalistItem>
                                <StyledDataContentMetalistTerm
                                    title={localized["Label.ViewCount"]}
                                >
                                    <i className="fas fa-eye"></i>
                                </StyledDataContentMetalistTerm>
                                <StyledDataContentMetalistDetail>
                                    {props.view.toLocaleString()}
                                </StyledDataContentMetalistDetail>
                            </StyledDataContentMetalistItem>
                        )}
                        {/* アップデート日時 */}
                        <StyledDataContentMetalistItem>
                            <StyledDataContentMetalistTerm
                                title={localized["Label.UpdateDate"]}
                            >
                                <i className="fas fa-calendar-alt"></i>
                            </StyledDataContentMetalistTerm>
                            <StyledDataContentMetalistDetail>
                                {props.date}
                            </StyledDataContentMetalistDetail>
                        </StyledDataContentMetalistItem>
                    </StyledDataContentMetalist>
                    <StyledDataContentActionlist>
                        {props.isSponsorUser === false && window.dataUser.isLogin === true && (
                            // スポンサーユーザー以外の場合のみ表示
                            <>
                                {/* お気に入りボタン */}
                                <StyledDataContentActionlistItem>
                                    <ButtonFavorite
                                        isFavorite={props.isFavorite}
                                        operationId={props.operationId}
                                        setIsFavorite={props.setIsFavorite}
                                    />
                                </StyledDataContentActionlistItem>
                                {/* 評価ボタン */}
                                <StyledDataContentActionlistItem>
                                    <ButtonRate
                                        isRate={props.isRate}
                                        operationId={props.operationId}
                                        rateCount={props.rateCount}
                                        setIsRate={props.setIsRate}
                                        setRateCount={props.setRateCount}
                                        isCollaboration={props.isCollaboration}
                                    />
                                </StyledDataContentActionlistItem>
                            </>
                        )}
                    </StyledDataContentActionlist>
                </StyledDataContent>
                {/* 執刀医リスト */}
                <StyledDataSurgeonlist>
                    <Surgeonlist
                        fnSetModalEdit={props.fnSetModalEdit}
                        isEditPage={props.isEditPage}
                        onColor="sub"
                        surgeonlist={props.surgeonlist}
                    />
                </StyledDataSurgeonlist>
                {/* 症例タグリスト */}
                <Taglist
                    fnSetModalEdit={props.fnSetModalEdit}
                    isEditPage={props.isEditPage}
                    taglist={props.taglist}
                />
            </StyledDataContents>
        </StyledData>
    );
};
